module.exports = __webpack_public_path__ + "img/lockPermission.f3621183.svg";